import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PublicHome from '../screens/PublicHome/PublicHome';
import PublicEvent from '../screens/PublicEvent/PublicEvent';
import PublicDiscover from '../screens/PublicDiscover/PublicDiscover';
import Registration from '../screens/Registration/Registration.web';
import VerificationCode from '../screens/VerificationCode/VerificationCode';
import LogIn from '../screens/Auth/LogIn.web';
import HowItWorks from '../screens/StaticPages/HowItWorks';
import Terms from '../screens/StaticPages/Terms';
import Privacy from '../screens/StaticPages/Privacy';
import Contact from '../screens/StaticPages/Contact';
import Jobs from '../screens/StaticPages/Jobs';
import About from '../screens/StaticPages/About';
import Margrit from '../screens/StaticPages/Margrit';
import Imprint from '../screens/StaticPages/Imprint';
import BecomeAHost from '../screens/StaticPages/BecomeAHost';
import { Helmet } from 'react-helmet';
import Favicon from '../../web/public/favicon.ico';
import TouchIcon from '../../web/public/logo192.png';
import OGImage from '../../web/public/og-image.png';

function PublicRoutes() {
  return (
    <Router>
      <Helmet>
        <link rel="shortcut icon" href={Favicon} />
        <link rel="apple-touch-icon" href={TouchIcon} />
        <meta name="og:image" content={OGImage} />
      </Helmet>
      <Switch>
        <Route path="/verify">
          <VerificationCode />
        </Route>
        <Route path="/login">
          <LogIn />
        </Route>
        <Route path="/register">
          <Registration />
        </Route>
        <Route path="/discover">
          <PublicDiscover />
        </Route>
        <Route path="/events/:id">
          <PublicEvent />
        </Route>
        <Route path="/privacy">
          <Privacy />
        </Route>
        <Route path="/how-it-works">
          <HowItWorks />
        </Route>
        <Route path="/become-a-host">
          <BecomeAHost />
        </Route>
        <Route path="/terms">
          <Terms />
        </Route>
        <Route path="/imprint">
          <Imprint />
        </Route>
        <Route path="/jobs">
          <Jobs />
        </Route>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/margrit">
          <Margrit />
        </Route>
        <Route path="/">
          <PublicHome />
        </Route>
      </Switch>
    </Router>
  );
}

export default PublicRoutes;
